import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba años buscando algo que entendiera lo que vivimos después de los 50. A los 10 días ya tenía claridad mental y energía estable. Hoy me siento como yo otra vez.',
  name: 'María Elena R.',
  age: '54 años · Colombia'
}, {
  quote: 'No tuve que cambiar mi rutina entera. Solo pequeños ajustes que marcaron una gran diferencia. Mi sueño mejoró desde la primera semana. Lo recomiendo de corazón.',
  name: 'Carmen V.',
  age: '56 años · México'
}];
export const TestimonialsSection = () => {
  return <Section bg="bg-cream-light" data-id="element-309">
      <FadeIn data-id="element-310">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-311">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-brown mb-4 leading-tight" data-id="element-312">
            Mujeres reales.{' '}
            <span className="text-gold italic font-normal" data-id="element-313">
              Cambios reales.
            </span>
          </h2>
          <p className="text-lg text-brown-light" data-id="element-314">
            Aquí van sus palabras exactas.
          </p>
        </div>
      </FadeIn>

      <StaggerContainer className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-315">
        {testimonials.map((testimonial, idx) => <StaggerItem key={idx} data-id="element-316">
            <div className="bg-white border border-cream-dark rounded-3xl p-8 md:p-10 shadow-md h-full flex flex-col" data-id="element-317">
              <div className="flex gap-1 mb-5" data-id="element-318">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-319" />)}
              </div>
              <p className="text-brown-light leading-relaxed italic flex-1 mb-6" data-id="element-320">
                "{testimonial.quote}"
              </p>
              <div data-id="element-321">
                <p className="font-bold text-brown text-lg" data-id="element-322">
                  {testimonial.name}
                </p>
                <p className="text-brown-light text-sm" data-id="element-323">{testimonial.age}</p>
              </div>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};